import { render, staticRenderFns } from "./BusListBackPage.vue?vue&type=template&id=9f2cc3fe&scoped=true"
import script from "./BusListBackPage.vue?vue&type=script&lang=js"
export * from "./BusListBackPage.vue?vue&type=script&lang=js"
import style0 from "./BusListBackPage.vue?vue&type=style&index=0&id=9f2cc3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2cc3fe",
  null
  
)

export default component.exports